import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import useMutate from "../../../../../../hooks/useMutate";
import { updateCard } from "../../../../../../services/apiCards";

export function useMessageBoxActions({
  cardId,
  cardDescription,
  setCardTitle,
}) {
  const queryClient = useQueryClient();

  const { mutate } = useMutate(
    updateCard,
    ["watching"],
    () => {},
    (response) => {
      queryClient.invalidateQueries({
        queryKey: ["mineCards"],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ["card", cardId],
      });
      toast.success(response.data.message);
    },
    (error) => {
      toast.error(error.response.data.message);
    }
  );

  const applySuggestedChanges = useCallback(
    (parsedData) => {
      cardDescription.set(parsedData?.suggestedDescription);
      setCardTitle(parsedData?.suggestedTitle);

      mutate({
        card_id: cardId,
        data: { title: parsedData?.suggestedTitle },
      });
    },
    [cardDescription, cardId, mutate, setCardTitle]
  );

  return { applySuggestedChanges };
}
